//@ts-nocheck
import { useState, useEffect } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  BlogSection,
  ArticleWrap,
  BlogWrapContent,
  MenuWrap
} from '@components/Fblog.styles';
import { LogoWhite } from '@assets/svgs';
import Menu from '@components/Menu/index';
import Footer from '@components/Footer';
import { CWriting } from '@data/copywriting';
import vision_magazine from '@assets/vision_magazine.png';
import womenlife_magazine from '@assets/womenlife_magazine.png';

const Program: NextPage = () => {
  const [scroll, setScroll] = useState(false);
  const [gapC] = useState('15px');

  const message = 'The Martin’s business coaching program';
  const storeurl = '';
  const startdate = '13/01/2026';
  const deadlinedate = '13/12/2025';
  const seats = '12';

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <Layout
        showHeader
        showCopyheader
        animationHeader="header"
        showFashionDesktop
        showMenu
        color="#000"
        email="george.martins@jorgedd.com"
        whatAppmsg="Hello,%0a%0aI would like to talk about the blue moonlight collection with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0aMy number:"
        whatAppLink="I'm looking forward to speak about your project. Click here to connect with me!"
        logo={<LogoWhite />}
      >
        <BlogSection>
          <ArticleWrap>
            <div className={scroll ? 'onScrollBottomMenu' : 'onScrollTopMenu'}>
              <h1>Business Coaching.</h1>
              <MenuWrap>
                <Menu
                  showCopywritingMenu
                  subscribeText="Subscribing to our news and latest. Be the first to know about what’s
            happening in the fashion world. The most talented Designers,
            Shows and the most talented Fashion Writers."
                />
              </MenuWrap>
            </div>

            <BlogWrapContent>
              <h2 style={{ textAlign: 'center' }}>
                THE MARTIN'S HOUSE EDITORIAL COACHING PROGRAMME.
              </h2>
              <br />
              <br />
              <Image
                src={womenlife_magazine}
                width={600}
                height={1024}
                alt="Ward 4"
                style={{ maxWidth: '100%' }}
              />
              <h3>Why Wednesdays?</h3>
              <p style={{ width: '100%' }}>
                Because is on Wednesdays, that The Martin's House Editorial,
                meet the women CEOs for life - The ones who will rule the world.
                <br />
                <br />
                It's you...
              </p>
              <h3>1- The Invitation</h3>
              <p style={{ width: '100%' }}>
                This is more than coaching. It's a Kingdom commission. Martin's
                Coaching is a 10-week immersion designed for business managers
                and women of vision who desire to lead, build, and dress with
                purpose.
                <br />
                <br />
                You won't just discover your "why." You'll build your business
                God's way - with clarity, excellence, and anointing.
              </p>
              <h3>2- What's included?</h3>
              <p style={{ width: '100%' }}>
                <b>Duration:</b> 10 Weeks
                <br />
                <b>Format:</b> Live Weekly Sessions + Private Consultation.
                <br />
                <b>Cohort Size:</b> Maximum 12 participants.
                <br />
                <br />
                <b>Each participant receives:</b>
                <br />
                <br />
                <b>1- 10 Coaching Modules</b> (purpose, strategy, structure,
                wardrobe & vision alignment
                <br />
                <b>2- 1 Private Consultation</b> (personal business or calling
                audit)
                <br />
                <b>3- The Martin's Wardrobe for Purpose Guide</b> (how to dress
                for every business setting)
                <br />
                <b>4- Official Certificate</b>
              </p>
              <h3>Investment Options.</h3>
              <p style={{ width: '100%' }}>
                <b>The Standard Group Experience.</b>
                <br />
                <b>Investment: $1,777 per person</b>
                <br />
                <br />
                <b>Payment Plan:</b>
                <br />
                <br />
                1- $777 deposit at registration
                <br />
                2- 2 monthly payments of $500
                <br />
                <br />
                This is the core program, crafted for women and leaders ready to
                align business with divine order and visible excellence.
              </p>
              <h3>4- The VIP mentorship tier (Limited 3 seats per season).</h3>
              <p style={{ width: '100%' }}>
                <b>Investment: $5,555 per person</b>
                <br />
                <br />
                Includes everything in the group program plus:
                <br />
                <br />
                1- 3 months of private 1:1 mentorship.
                <br />
                2- Tailored wardrobe & brand identity audit.
                <br />
                3- Voice-note support & personal prophetic accountability.
                <br />
                4- Direct mentorship access to Martin's business team.
              </p>
              <h3>5- Exclusive Bonuses (for early enrolment)</h3>
              <p style={{ width: '100%' }}>
                If you register during the first 7 days of launch:
                <br />
                <br />
                1- Receive "The Builder's Anointing" Devotional eBook (digital
                edition).
                <br /> 2- Access a Bonus Live Q&A Session: "Profit & Divine
                Strategy".
                <br /> 3- Private invitation to the next Martin's Business
                Gathering.
              </p>
              <h3>6- Enrolment details.</h3>
              <p style={{ width: '100%' }}>
                <b>Next Cohort Begins:</b> {startdate}
                <br />
                <b>Application Deadline:</b> {deadlinedate}
                <br />
                <b>Seats Available:</b> {seats}
                <br />
                <b>Location:</b> Online (via Zoom)
                <br />
                <br />
                You will receive your confirmation email, program guide, and
                first assignment within 48/72 hours of enrollment.
              </p>
              <h3>7- Is this for you?</h3>
              <p style={{ width: '100%' }}>
                This program is for you if:
                <br />
                <br />
                1- You're a woman or manager ready to build with purpose, not
                pressure.
                <br />
                2- You want to understand what God is truly calling your
                business to do.
                <br />
                3- You're ready to integrate wisdom with practical structure.
                <br />
                4- You feel a divine nudge to lead with excellence and faith.
                <br />
                5- You desire mentorship that carries both strategy and
                anointing.
              </p>
              <h3>8- How to enrol?</h3>
              <p style={{ width: '100%' }}>
                1- Click <b>"Apply Now"</b> or submit your interest form.
                <br />
                2- You'll receive an email to book your discovery call (if
                required).
                <br />
                3- Once accepted, submit your <b>$777 deposit</b> to reserve
                your seat.
                <br />
                4- Receive your onboarding materials and join your prophetic
                cohort.
              </p>
              <h3>9- From the Founder</h3>
              <p style={{ width: '100%' }}>
                <i>
                  "This is not a business course - it's a divine realignment.
                  <br />
                  Heaven is raising women who can discern seasons, build with
                  beauty, and lead with power. If you're reading this, you're
                  being invited into more than a program - you're being invited
                  into a movement."
                  <br />
                  <br />
                  G. Martin's,
                  <br /> Founder | Mentor | Editor & Creative Director
                  <br />
                  The Martin's House
                </i>
              </p>
              <h3>10- Enrolment now open.</h3>
              <p style={{ width: '100%' }}>
                <b>
                  Secure your place. Step into your purpose. Build God's way.
                </b>
              </p>
            </BlogWrapContent>
            {/* <div
              className="collectionWrap"
              style={{ marginTop: '30px', columnGap: gapC }}
            >
              <Link href={storeurl} target="_blank">
                <div className="imgWrap">
                  <Image
                    src={article_28}
                    width={600}
                    height={1024}
                    alt="Ward 4"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              </Link>
              <Link href={storeurl} target="_blank">
                <div className="imgWrap">
                  <Image
                    src={lady_2}
                    width={600}
                    height={1024}
                    alt="Ward 4"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              </Link>
              <Link href={storeurl} target="_blank">
                <div className="imgWrap">
                  <Image
                    src={lady_3}
                    width={600}
                    height={1024}
                    alt="Ward 4"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              </Link>
            </div> */}

            <BlogWrapContent style={{ marginTop: '40px' }}>
              {/* <p>
                <b style={{ fontSize: CWriting.phoneNumber[0].priceSize }}>
                  $20
                </b>
              </p> */}
              {/* <br /> */}
              <Link
                href="mailto:applications.martinswriterscoaching@jorgedd.com?subject=The%20Martin's%20House%20Coaching%20Programme%20Application&body=Hello,%0A%0AWelcome to Martin's business coaching program. Please fill out the form below, and we'll get in touch very soon.%0A%0A%0AFull%20Name:%0A%0AEmail:%0A%0APhone:%0A%0ABusiness%20Name:%0A%0ABusiness%20Vision:%0A%0AGoals%20for%20Program:%0A%0AHow%20Did%20You%20Hear%20About%20Us:%0A%0A%0AWith elegance,%0AGeorge Martin's%0AFounder | Martin's"
                target="_blank"
                className="btn"
              >
                Apply Now
              </Link>
              <br />
              <Link href="https://payhip.com/b/4sW0v" className="btn">
                Apply for Membership plan
              </Link>
            </BlogWrapContent>
          </ArticleWrap>
          <Footer isClass="footer" />
        </BlogSection>
      </Layout>
    </>
  );
};

export default Program;
